import React, { useCallback, useMemo } from 'react'
import { Row, Col } from 'react-grid-system'

import Dropdown from '../../common/form/fields/dropdown/dropdown'
import DateInput from '../../common/form/fields/dateInput/dateInput'
import { LoanAndFieldTransferViewProps } from '../actionsWorkflow.type'
import { Option } from '../../common/form/fields/dropdown/types'
import { Input } from '../../common/form/fields'

export const LoanAndFieldTransferView = ({
   validationErrors,
   handleDropdownChange,
   handleCommentChange,
   connectionOptions,
   locationOptions,
   handleDateChange,
   cartOptions,
   enableLocationTracking,
}: LoanAndFieldTransferViewProps) => {
   const handleConnectionChange = useCallback(
      (option: Option) => handleDropdownChange('Connection', option),
      [handleDropdownChange]
   )

   const handleLocationChange = useCallback(
      (option: Option) => handleDropdownChange('Location', option),
      [handleDropdownChange]
   )

   const handleDueBackChange = useCallback(
      (date) => handleDateChange('DueBack', date),
      [handleDateChange]
   )

   const handleCommentFieldChange = useCallback(
      (comment) => handleCommentChange('Comment', comment),
      [handleCommentChange]
   )

   const selectedDueBackDate = useMemo(() => {
      if (cartOptions?.dueBackDate) {
         return Date.parse(cartOptions.dueBackDate)
      }
      return null
   }, [cartOptions?.dueBackDate])

   return (
      <>
         <Row gutterWidth={20}>
            <Col md={6} lg={6}>
               <Dropdown
                  error={validationErrors?.Connection}
                  name="Connection"
                  onChange={handleConnectionChange}
                  options={connectionOptions}
                  id="Connection"
                  label="Connection"
                  placeholder="Connection"
                  isMulti={false}
                  required
               />
            </Col>
            <Col md={6} lg={6}>
               <DateInput
                  id="DueBackDate"
                  label="Due back (optional)"
                  onChange={handleDueBackChange}
                  selectedDate={selectedDueBackDate}
                  minDate={new Date()}
               />
            </Col>
         </Row>
         <Row gutterWidth={20}>
            {enableLocationTracking && (
               <Col md={6}>
                  <Dropdown
                     name="NewLocation"
                     onChange={handleLocationChange}
                     options={locationOptions}
                     id="NewLocation"
                     label="New Location (optional)"
                     placeholder="New Location (optional)"
                     isMulti={false}
                  />
               </Col>
            )}
            <Col md={6}>
               <Input
                  id="Comment"
                  label="Comment (optional)"
                  onChange={handleCommentFieldChange}
               />
            </Col>
         </Row>
      </>
   )
}
